import PropTypes from 'prop-types';
import './DisclaimerMark.scss';
import {Tooltip} from '@mui/material';

const DisclaimerMark = ({title}) => (
  <Tooltip data-testid="DisclaimerMark"
           classes={{
             tooltip: 'disclaimer-tooltip'
           }}
           title={title}>
    <span className="DisclaimerMark">
      *
    </span>
  </Tooltip>
);

DisclaimerMark.propTypes = {
  title: PropTypes.string,
};

DisclaimerMark.defaultProps = {
  title: 'This data point was edited by the author of this CMA and has not been verified by Cotality',
};

export default DisclaimerMark;
